import Vue from "vue";
import VueI18n from "vue-i18n";
import { Locale } from "vant";
import messages from "./lang";
import vantZH from "vant/lib/locale/lang/zh-CN";
import vantEN from "vant/lib/locale/lang/en-US";
import vantHK from "vant/lib/locale/lang/zh-HK";
Vue.use(VueI18n);
Vue.use(Locale);
const vantLangs = {
  'en': vantEN,
  "zh-CN": vantZH,
  "zh-HK": vantHK
};

const lang = navigator.language || navigator.userLanguage; // 语言标识,
const vantLang = vantLangs[lang] ? vantLangs[lang] : "en"; // vant国际化设置
const i18n = new VueI18n({
  locale: lang === "zh-CN" ? "zh-CN" : lang === "zh-HK" ? "zh-HK" : "en", // 语言标识,
  messages: messages
});
// vant i18n
Locale.use(lang, vantLang);
export default i18n;
